<template>
    <div>
        <psi-page-title
            :title="page.title"
            :icon="page.icon"
            :breadcrumbs="breadcrumbs"
        >
        </psi-page-title>
        <v-card class="mt-4">
            <v-card-text>
                <psi-content-loader
                    type="linear"
                    v-if="loading"
                ></psi-content-loader>
                <program-instructor
                    v-if="!loading && Object.keys(currentInstructor).length > 0"
                    @select-session="selectSession"
                    :key="currentInstructor.id"
                    :instructor="currentInstructor"
                ></program-instructor>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import ProgramInstructor from "../components/ProgramInstructor.vue";
import HomeLink from "@/mixins/homelink";
export default {
    components: {
        ProgramInstructor,
    },
    mixins: [HomeLink],
    name: "instructor-dashboard",
    data() {
        return {
            instructorId: null, // we set the instructor ID from the route or from the logged in user
        };
    },
    computed: {
        ...mapGetters("Programs", ["currentInstructor", "loading"]),
        page() {
            return {
                title:
                    Object.keys(this.currentInstructor).length == 0
                        ? "Instructor Dashboard"
                        : this.currentInstructor.name,
                icon: "mdi-account",
            };
        },
        breadcrumbs() {
            return [
                Object.assign(
                    {
                        text: "Home",
                        disabled: false,
                    },
                    this.homeUrl
                ),
                {
                    text: "Programs",
                    disabled: false,
                    to: { name: "Program Dashboard" },
                },
                {
                    text: "Instructor Dashboard",
                    disabled: false,
                },
            ];
        },
    },
    watch: {
        authUser: {
            immediate: true,
            handler(user) {
                if (
                    !this.instructorId &&
                    !this.$_.get(this.$route, "to.query.instructorId", "") &&
                    this.$_.get(user, "id", "") &&
                    this.$_.get(user, "role_name", "") === "Instructor"
                ) {
                    this.instructorId = user.id;
                    this.getCurrentInstructor({
                        instructorId: user.id,
                        programId: 0,
                        sessionId: 0,
                    });
                }
            },
        },
        $route: {
            immediate: true,
            deep: true,
            handler(to) {
                let {
                    instructorId = 0,
                    programId = 0,
                    sessionId = 0,
                } = to.query;

                if (instructorId === 0 && !this.instructorId) {
                    // see if we are logged in as an instructor
                    if (this.isInstructor) {
                        instructorId = this.authUser.id;
                        // set it on the component so we won't call it from authUser
                        this.instructorId = instructorId;
                    }
                }
                if (to.name === "Instructor Dashboard") {
                    if (instructorId !== 0) {
                        this.getCurrentInstructor({
                            instructorId,
                            programId,
                            sessionId,
                        });
                    } else if (!this.instructorId) {
                        this.SET_CURRENT_INSTRUCTOR({});
                    }
                }
            },
        },
    },

    methods: {
        ...mapActions("Programs", ["getCurrentInstructor"]),
        ...mapMutations("Programs", ["SET_CURRENT_INSTRUCTOR"]),
        selectSession(session) {
            this.getCurrentInstructor({
                instructorId: this.currentInstructor.id,
                programId: this.currentInstructor.program.id,
                sessionId: session.id,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>